// extracted by mini-css-extract-plugin
export var closeButton = "useModal-module--close-button--f9df9";
export var disableDocumentScroll = "useModal-module--disable-document-scroll--e0a5f";
export var grey = "useModal-module--grey--d66fa";
export var inlineUdo2pk2 = "useModal-module--inline-udo2pk2--10123";
export var inlineUdo2pke = "useModal-module--inline-udo2pke--b0bc8";
export var modal = "useModal-module--modal--2fb2c";
export var navy = "useModal-module--navy--1a999";
export var overlay = "useModal-module--overlay--37911";
export var referralModal = "useModal-module--referralModal--9b8f7";